/* eslint-disable no-use-before-define */
import React from 'react'
import { Dot } from 'recharts'
import { $ } from '../../../twd/all';

export default ({...props}) => {
    let {payload} = props
    return <Dot
        onMouseOver={activateBenchmarkShape}
        onMouseOut={deactivateBenchmarkShape}
        className={`benchmarks-dot-${payload.x} benchmark-${payload.benchmark}`}
        {...props} />
}

const activateBenchmarkShape = (e, ev) => {
    let el = $(ev.currentTarget)
    let p = e.payload || {}
    el.attr('data-benchmark', p.benchmark)
    el.attr('data-maturity-years', p.maturityYearValue)
    el.attr('data-yield', p.yieldValue)

    $('.' + e.className)
    .each(function(i, a){
        let j = $(a)
        let c = $(a).attr('fill')
        j.attr({ r:4, stroke:c, fill:'#fff' })
    })
}

const deactivateBenchmarkShape = (e) => {
    $('.' + e.className)
    .each(function(i, a){
        let j = $(a)
        let c = $(a).attr('stroke')
        j.attr({ r:2, stroke:c, fill:c })
    })

}


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/benchmark/shape.js